import StatusCardType from '@/common/helios/OrderStatusCard/StatusCardType';
import OrderState from '~/constants/common/OrderState';

export default function getStatusCardType(
  orderState: OrderState
): StatusCardType | null {
  switch (orderState) {
    case OrderState.OrderPlaced:
      return StatusCardType.OrderPlaced;
    case OrderState.InProgress:
    case OrderState.InProgressWithTradeIn:
      return StatusCardType.PurchaseInProgress;
    case OrderState.RecentlyPurchased:
      return StatusCardType.Purchased;
    case OrderState.Reserved:
      return StatusCardType.Reserved;
    default:
      return null;
  }
}
